import { IconButton, makeStyles } from "@material-ui/core";
import { ChangeEvent } from "react";
import {
  HeaderWithButtons,
  SortButtonAndMenu,
  FilterButton,
  Searchbar,
} from ".";
import { ISortItem, OrderSortType } from "../components-pages/Orders";
import SearchRoundedIcon from "@material-ui/icons/SearchRounded";
import { roleName } from "../utils/roles";
import { textButtonHoverAndActive } from "../utils/styles/buttonStyles";

interface IProps {
  sortTypes: ISortItem[];
  sortType: OrderSortType;
  handleSortSelect: (sortItem: ISortItem) => void;
  onFilterSubmit: (thisFilter: any) => void;
  filterOptions: any;
  filter: any;
  searchOpen: boolean;
  query: string;
  onSearchCancel: () => void;
  onSearchChange: (
    e: ChangeEvent<HTMLTextAreaElement | HTMLInputElement>
  ) => void;
  onSearchIconClick: () => void;
}

export const OrdersTabHeader = ({
  sortTypes,
  sortType,
  handleSortSelect,
  onFilterSubmit,
  filterOptions,
  filter,
  searchOpen,
  query,
  onSearchCancel,
  onSearchChange,
  onSearchIconClick,
}: IProps) => {
  const classes = useStyles();
  return (
    <>
      <HeaderWithButtons.ButtonArea>
        <div className={classes.buttonSet}>
          <SortButtonAndMenu
            data-automation="sort-button"
            menuItems={sortTypes.map((sortItem: ISortItem) => ({
              title: sortItem.title,
              value: sortItem.value,
              handleSelect: () => handleSortSelect(sortItem),
            }))}
            selectedSortType={sortType}
          />
          <FilterButton
            searchableList={["Shop"]}
            dateKey="Date"
            defaultOption={roleName() === "Admin" ? "Shop" : "Date"}
            data-automation="filter-button"
            onSubmit={onFilterSubmit}
            inButtonSet
            options={filterOptions}
            filter={filter}
          />
          <IconButton
            data-automation="search-button"
            className={classes.searchIconButton}
            color="primary"
            onClick={() => onSearchIconClick()}
          >
            <SearchRoundedIcon color="primary" className={classes.searchIcon} />
          </IconButton>
        </div>
      </HeaderWithButtons.ButtonArea>
      <Searchbar
        query={query}
        isOpen={searchOpen}
        placeholder="Search Orders"
        onCancel={() => onSearchCancel()}
        onChange={(event) => onSearchChange(event)}
      />
    </>
  );
};
const useStyles = makeStyles({
  searchIcon: {
    width: 24,
    height: 24,
  },
  searchIconButton: {
    width: 40,
    height: 40,
    marginLeft: 8,
    ...textButtonHoverAndActive
  },
  buttonSet: {
    display: "flex",
    flexDirection: "row",
    paddingRight: "24px",
  },
});
